(function($) {

	'use strict';

	var init = function() {
        if($('.home.page').length > 0) {
            if($('.fp-hero__iframe').length > 0) {         
                loadVideo();
            }
            productCarousel();
            instaCarousel();
        }
    };
    
    var loadVideo = function() {
        if($(window).outerWidth() > 991) {
            var source = $('.fp-hero__iframe').data('src');
            $('.fp-hero__iframe').attr("src", source).addClass('visible');
        }
    }

    var productCarousel = function() {
        var $productOwls = [$('.fp-swimrun__repeater.owl-carousel'), $('.fp-diving__repeater.owl-carousel')];

        $productOwls.forEach(function($productOwl) {
            $productOwl.owlCarousel({
                loop: true,
                items: 1,
                smartSpeed: 600,
                nav: true, 
                responsive: {
                    0: {
                        touchDrag: true,
                        mouseDrag: true,
                        margin: 500,
                    },
                    992: {
                        touchDrag: false,
                        mouseDrag: false,
                        margin: 800,
                    }
                }
            });
        })
    }

    var instaCarousel = function() {

        var items = Math.trunc($(window).outerWidth() / 396);

        var $instaOwl = $('.fp-insta__repeater.owl-carousel');

        $instaOwl.owlCarousel({
            loop: true,
            slideBy: 1,
            smartSpeed: 600,
            nav: false, 
            touchDrag: true,
            mouseDrag: true,
            center: true,
            autoplay: true,
            autoplayTimeout: 5000,
            stagePadding: 50,
            margin: 21,
            responsive: {
                0: {
                    items: 1,
                },
                452: {
                    items: items,
                }
            }
            
        });

        $(window).resize(function() {

            items = Math.trunc($(window).outerWidth() / 396);

            $instaOwl.trigger('destroy.owl.carousel');

            $instaOwl.owlCarousel({
                loop: true,
                slideBy: 1,
                smartSpeed: 700,
                nav: false,
                dots: false,
                touchDrag: true,
                mouseDrag: true,
                center: true,
                autoplay: true,
                autoplayTimeout: 7000,
                stagePadding: 50,
                margin: 21,
                autoWidth: true,
                autoHeight: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    452: {
                        items: items,
                    }
                }
                
            });

        });

    }

        

	$(document).ready(function() {
		init();
	});

})(jQuery);